import React, { useCallback, useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'
import ApexCharts from 'apexcharts'

import * as optionsChart from 'components/ChartArea/chartOptions'
import HeadtMapLoadre from './HeadtMapLoadre'
import { emptySeriesHeatmap } from './emptyData'

const HeatmapChart = ({
  categoriesX,
  seriesY = [],
  isFetching,
  classNameContainer = '',
}) => {
  const handleClick = useCallback(
    (e, w, data) => {
      const { dataPointIndex, seriesIndex } = data
      console.log(seriesY[seriesIndex]?.itemData[dataPointIndex])
    },
    [seriesY]
  )

  const getTooltip = useCallback(
    (props) => {
      const { w, dataPointIndex, seriesIndex } = props

      const _day = w.globals.labels[dataPointIndex]

      const _time = w.globals.seriesNames[seriesIndex]

      const currentValue = seriesY[seriesIndex]?.currentData[dataPointIndex]

      return `<div class='tooltip_container'>
                  <span class='xaxis_text'>${_day} at ${_time}</span>
                  <span class='yaxis_text'>
                      ${Number(currentValue).toFixed(2)}
                      <span>kWh</span>
                  </span>
              </div>`
    },
    [seriesY]
  )

  const options = {
    ...optionsChart,
    chart: {
      ...optionsChart.chart,
      id: 'heatmap222',
      events: {
        click: handleClick,
      },
    },
    xaxis: {
      ...optionsChart.xaxis,
      categories: categoriesX,
      type: 'category',
    },
    grid: {
      show: false,
    },
    stroke: {
      show: true,
      colors: ['#fff'],
      width: 2,
    },
    yaxis: {
      labels: {
        show: true,
        formatter: (value, index) => {
          return index % 2 ? value : ''
        },
      },
    },
    tooltip: {
      enabled: !!seriesY?.length,
      custom: getTooltip,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0.01,
        },
      },
      active: {
        filter: {
          type: 'none',
        },
      },
    },
  }

  useEffect(() => {
    if (seriesY?.length) {
      ApexCharts.exec('heatmap222', 'updateOptions', options)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seriesY])

  const { width } =
    document
      .getElementsByClassName('apexcharts-heatmap')[0]
      ?.getBoundingClientRect() || {}

  return (
    <div className={`heatmap_container ${classNameContainer}`}>
      <ReactApexChart
        options={options}
        series={seriesY || emptySeriesHeatmap}
        type="heatmap"
        height={425}
      />
      {isFetching && <HeadtMapLoadre width={width} />}
    </div>
  )
}

export default HeatmapChart
